import { NEW_NOTE, GET_NOTES, UPDATE_NOTE, DELETE_NOTE, SHOW_SPINNER, HIDE_SPINNER, SHOW_NOTIFICATION } from '../types';
import api from '../../api';
import { addRecentNote, delRecentNote } from './index';
import sessionErrHandler from './sessionErrHandler';

export const getNotes = () => async dispatch => {
  dispatch({ type: SHOW_SPINNER, payload: 'Pobieram notatki'});

  let response;
  try {
    response = await api.get('/note/', { withCredentials: true });
    if (response.status === 200) {
      dispatch({ type: GET_NOTES, payload: response });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Error status: ' + response.status, type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Wystąpił problem z załadowaniem notatek', dispatch);
  }

  dispatch({ type: HIDE_SPINNER });
}

export const newNote = ({ title, content }) => async dispatch => {
  dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'info', message: 'zapisuję notatkę' }});

  const options = {
    method: 'post',
    data: { title, content },
    url: '/note',
    withCredentials: true
  }

  let response;
  let id;
  try {
    response = await api(options);
    if (response.status === 200) {
      id = response.data.id;
      dispatch(addRecentNote(id));
      dispatch({ type: NEW_NOTE, payload: { id, title, content, saved: true } });
      dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'success', message: 'Notatka zapisana' }});
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd zapisu notatki: ' + response.status, type: 'error' }
      });
      dispatch({ type: NEW_NOTE, payload: { title, content, saved: false } });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd zapisu notatki', dispatch);
    if (e.message !== 'Request failed with status code 401') 
      dispatch({ type: NEW_NOTE, payload: { title, content, saved: false } });
  }

}

export const saveNote = ({ id, title, content }) => async dispatch => {
  dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'info', message: 'zapisuję notatkę' }});

  const options = {
    method: 'put',
    data: { title, content },
    url: `/note/${id}`,
    withCredentials: true
  }

  let response;
  try {
    response = await api(options);
    if (response.status === 200) {
      dispatch({ type: UPDATE_NOTE, payload: { id, title, content, saved: true } });
      dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'success', message: 'Notatka zapisana' }});
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd zapisu notatki: ' + response.status, type: 'error' }
      });
      dispatch({ type: UPDATE_NOTE, payload: { id, title, content, saved: false } });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd zapisu notatki', dispatch);
    if (e.message !== 'Request failed with status code 401') 
      dispatch({ type: UPDATE_NOTE, payload: { id, title, content, saved: false } });
  }
}

export const deleteNote = id => async dispatch => {
  dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'info', message: 'Usuwam notatkę' }});

  const options = {
    method: 'delete',
    data: { id },
    url: `/note/${id}`,
    withCredentials: true
  }

  let response;
  try {
    response = await api(options);
    if (response.status === 200) {
      dispatch({ type: DELETE_NOTE, payload: id });
      dispatch({ type: SHOW_NOTIFICATION, payload: { type: 'success', message: 'Notatka usunięta' }});
      dispatch(delRecentNote(id));
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: 'Błąd podczas usuwania notatki: ' + response.status, type: 'error' }
      });
    }
  } catch (e) {
    sessionErrHandler(e, 'Błąd podczas usuwania notatki', dispatch);
  }
}
